
<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col md="12">
        <b-card>
          <div slot="header">
            <strong>Add news</strong>
          </div>
          <b-form>
            <b-form-group>
              <b-form-input id="newsTitle" 
                        type="text" 
                        autocomplete="name" 
                        v-model="newsData.title" 
                        size="lg" 
                        placeholder="Enter news title...">
              </b-form-input>
            </b-form-group>
            <b-form-group>
              <b-form-input id="newsTitle" 
                      type="text" 
                      autocomplete="name" 
                      v-model="newsData.subtitle" 
                      placeholder="Enter news subtitle...">
              </b-form-input>
            </b-form-group>
            <b-form-group>
              <b-form-textarea id="newsDescription"
                        v-model="newsData.description"
                        placeholder="Enter news description..."
                        :rows="3"
                        :max-rows="6"
                        size="sm">
              </b-form-textarea>
            </b-form-group>
            <b-form-group>
              <b-form-input id="newsSource" 
                      type="url" 
                      autocomplete="name" 
                      v-model="newsData.sourceUrl" 
                      placeholder="Enter source url...">
              </b-form-input>
            </b-form-group>
            <b-form-group
            label="Upload news front image"
            label-for="mediaFileInput"
            :label-cols="3"
            :horizontal="true">
              <b-form-file accept="image/*" id="mediaFileInput" :plain="true" v-model="newsData.mediaFile"></b-form-file>
          </b-form-group>
          <div slot="footer">
            <b-button v-on:click="confirmNewsButton" size="sm" variant="primary"><i class="fa fa-dot-circle-o"></i> Confirm News</b-button>
          </div>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import _ from 'underscore'
import { db } from '@/config/devowqlo';
import { storage } from '@/config/devowqlo';
import { auth } from '@/config/devowqlo';
import { functions } from '@/config/devowqlo';
export default {
  name: 'forms',
  firebase: {
    news: db.ref('news/published'),
    counts: db.ref('counts')
  },
  data () {
    return {
      newsData: {
        title: '',
        subtitle: '',
        description: '',
        sourceUrl: '',
        mediaFile: ''
      }
      
    }
  },
  created() {
    
    
  },
  methods: {
    confirmNewsButton () {
      this.addNews()
    },
    addNews(){

      this.uploadPictureFile();
    },
    uploadPictureFile(){
      console.log("Uploading media file...")
      const mediaName = (+new Date()) + '-' + this.newsData.mediaFile.name;
      const mediaMetadata = { contentType: this.newsData.mediaFile.type };
      const uploadTask = storage.ref().child("NewsFiles").child(mediaName).put(this.newsData.mediaFile, mediaMetadata)
        .then(snapshot => snapshot.ref.getDownloadURL())
        .then(url => this.createNewsDb(mediaName))
    },
    createNewsDb(mediaName){
      
      console.log("Creating news on DB...")
       
      const thumbMediaUrl = 'thumb_' + mediaName
      const dateNow = Date.now()

      var newsModel = { 
        title: this.newsData.title,
        subtitle: this.newsData.subtitle,
        description: this.newsData.description,
        mediaUrl: mediaName,
        thumbMediaUrl: thumbMediaUrl,
        created: dateNow,
        modified: dateNow
      }

      this.$firebaseRefs.news.push(newsModel)

      var countRef = this.$firebaseRefs.counts.child('newsCount').child('count')

      countRef.transaction(function(count) {
        if (count) {
          count = count + 1;
        }else{
          count = 1
        }
        return count;
      })

      this.$router.go(-1)
    
    }
  }
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>